import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import { AuthProvider } from './shared/contexts/AuthContext';
import { ErrorProvider } from './shared/contexts/ErrorContext';
import { AuthGuard } from './shared/components/AuthGuard';
import { AppLayout } from './shared/layout/AppLayout';
import { LoginPage } from './pages/login/LoginPage';
import { SearchPage } from './pages/search/SearchPage';
import { ClientDetailPage } from './pages/client/ClientDetailPage';
import { NotFoundPage } from './pages/error/NotFoundPage';
import { ForbiddenPage } from './pages/error/ForbiddenPage';

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
          borderRadius: 6,
          fontSize: 13,
        },
      }}
    >
      <AntApp>
        <ErrorProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/forbidden" element={<ForbiddenPage />} />

                <Route path="/app" element={<AuthGuard />}>
                  <Route element={<AppLayout />}>
                    <Route index element={<Navigate to="search" replace />} />
                    <Route path="search" element={<SearchPage />} />
                    <Route path="client/:id" element={<ClientDetailPage />} />
                  </Route>
                </Route>

                <Route path="/" element={<Navigate to="/app" replace />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </ErrorProvider>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
